import { useEffect } from 'react';

// Body class applied when this hook is active. Styled rules are injected once at module load.
const PAGE_CLASS = 'body-overflow-hook-page';

if (typeof document !== 'undefined' && !document.getElementById('body-overflow-hook-styles')) {
  const style = document.createElement('style');
  style.id = 'body-overflow-hook-styles';
  style.textContent = `
    @media print {
      .${PAGE_CLASS} {
        position: inherit !important;
        overflow: inherit !important;
      }
    }
  `;
  document.head.appendChild(style);
}

export const setBodyOverflow = (hidden = false, className = '') => {
  const elem = document.getElementsByTagName('body')[0];

  try {
    if (hidden) {
      elem.style['touch-action'] = 'none';
      elem.style.overflow = 'hidden';
      elem.style.position = 'fixed';
      elem.style.top = '0px';
      elem.style.bottom = '0px';
      elem.style.left = '0px';
      elem.style.right = '0px';
      elem.classList.add(className);
    } else {
      elem.style['touch-action'] = '';
      elem.style.overflow = '';
      elem.style.position = '';
      elem.style.top = '';
      elem.style.bottom = '';
      elem.style.left = '';
      elem.style.right = '';
      if (className) elem.classList.remove(className);
    }
  } catch (err) {
    console.warn(err);
  }
};

const useBodyOverflow = (props = {}) => {
  const { hidden } = props;

  useEffect(() => {
    setBodyOverflow(hidden, PAGE_CLASS);

    return () => {
      setBodyOverflow(false, PAGE_CLASS);
    };
  }, [hidden]);

  return {
    setBodyOverflow,
  };
};

export default useBodyOverflow;
